import contractPeriodStore from "./contractPeriodStore.js";
import costCentreStore from "./costCentreStore.js";
import costAllocatorStore from "./costAllocatorStore";
import billingPeriodStore from "./billingPeriodStore";
import costItemStore from "./costItemStore";
import consumptionAccountingStore from "./consumptionAccountingStore";
import dmeFileStore from "./dmeFileStore";
import exportLinkStore from "./exportLinkStore";
import exportLinkTypeStore from "./exportLinkTypeStore";
import billingPeriodCostCentreStore from "./billingPeriodCostCentreStore";
import tariffPlanComponentStore from "./tariffPlanComponentStore.js";
import tariffPlanModifiersStore from "./tariffPlanModifiersStore.js";
import tariffPlanOperandsStore from "./tariffPlanOperandsStore.js";
import tariffPlanTimeframesStore from "./tariffPlanTimeframesStore.js";
export default {
  namespaced: true,
  modules: {
    contractPeriodStore,
    costCentreStore,
    costAllocatorStore,
    billingPeriodStore,
    costItemStore,
    consumptionAccountingStore,
    dmeFileStore,
    exportLinkStore,
    exportLinkTypeStore,
    billingPeriodCostCentreStore,
    tariffPlanComponentStore,
    tariffPlanModifiersStore,
    tariffPlanOperandsStore,
    tariffPlanTimeframesStore
  }
};
